import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { PureButton } from '../../../basics';
import { Button, ChevronIcon } from '../../../components';
import { Breakpoint, ButtonSize } from '../../../enums';
import { useBreakpoint } from '../../../hooks';
import { ProductTileExpandedArea } from '../ProductTileExpandedArea';
import styles from './ProductTileButtonsBlock.module.scss';
const ProductTileButtonsBlock = ({ a11yButtonDetail, a11yPdpRedirectLabel, addToCartButtonData, className, isPortraitTile, name, services, url, }) => {
    const isDesktop = useBreakpoint(Breakpoint.XS);
    const [showServices, setShowServices] = useState(false);
    const servicesToggleRef = useRef(null);
    const isAddToCartButtonVisible = !addToCartButtonData?.isMobileOnly || (addToCartButtonData.isMobileOnly && !isDesktop);
    const handleServicesToggleClick = () => {
        services?.onToggleServices(showServices);
        setShowServices(!showServices);
    };
    const handleAddToCartButtonClick = (event) => {
        addToCartButtonData?.onClick(event);
    };
    useEffect(() => {
        servicesToggleRef.current?.blur();
    }, [showServices]);
    return (_jsxs("div", { className: classNames(className, {
            'mb-2x mb-xs-0': addToCartButtonData?.isMobileOnly,
            'mb-2x': addToCartButtonData && !addToCartButtonData?.isMobileOnly,
        }), children: [_jsxs("div", { className: classNames(styles.wrapper, 'd-grid', {
                    [styles.isPortraitTile]: isPortraitTile,
                    [styles.twoColumn]: services && addToCartButtonData,
                }), children: [services ? (_jsxs(PureButton, { onClick: handleServicesToggleClick, className: classNames(styles.expandButtonToggle, 'd-flex align-items-center justify-content-between py-1x py-xs-2x'), ref: servicesToggleRef, "aria-label": a11yButtonDetail, children: [services.caption, _jsx(ChevronIcon, { className: classNames(styles.expandedToggleIcon, {
                                    [styles.isExpanded]: showServices,
                                }) })] })) : null, addToCartButtonData ? (_jsx("div", { className: classNames(addToCartButtonData.className, styles.addToCartButtonHolder, {
                            'd-xs-none': addToCartButtonData.isMobileOnly,
                        }), children: isAddToCartButtonVisible && (_jsx(Button, { onClick: handleAddToCartButtonClick, className: classNames('w-100 px-0 px-xs-3x', styles.addToCartButton), disabled: addToCartButtonData.isDisabled, variant: addToCartButtonData.variant, color: addToCartButtonData.color, size: ButtonSize.ResponsiveXs, a11yText: addToCartButtonData.label, children: addToCartButtonData.label })) })) : null] }), services ? (_jsx(ProductTileExpandedArea, { hasCartButton: isAddToCartButtonVisible && Boolean(addToCartButtonData), showServices: showServices, setShowServices: setShowServices, services: services, name: name, url: url, a11yPdpRedirectLabel: a11yPdpRedirectLabel, className: classNames({
                    'mb-xs-0': !addToCartButtonData,
                }), isPortraitTile: isPortraitTile })) : null] }));
};
export { ProductTileButtonsBlock };
